import { Alert, Anchor, Badge, Box, Button, Group, NativeSelect, Paper, SimpleGrid, Stack, Table, Text, TextInput, Title } from '@mantine/core'
import AppPagination from './AppPagination'

function Person({ person }) {
  return (
    <Stack gap={4} style={{ overflowWrap: 'anywhere' }}>
      <Group gap="xs">
        {person.href ? <Anchor href={person.href} fw={600}>{person.name}</Anchor> : <Text size="sm">{person.name}</Text>}
        {person.deleted && <Badge size="xs" color="gray" variant="outline">退会済み</Badge>}
      </Group>
      {person.id && <Text size="xs" c="dimmed">ID {person.id}</Text>}
      {person.email && <Text size="xs" c="dimmed">{person.email}</Text>}
      {!person.href && person.name !== '未記録' && <Text size="xs" c="dimmed">氏名のみ記録</Text>}
    </Stack>
  )
}

function Status({ status }) {
  return <Badge color={status === 'confirmed' ? 'teal' : 'orange'} variant="light">{status === 'confirmed' ? '本登録' : '仮登録'}</Badge>
}

export default function AdminReferralRegistrations({ rows, totalCount, filters, errors, actionHref, pagination }) {
  return (
    <Stack gap="lg" maw={1280} mx="auto" p={{ base: 'sm', sm: 'xl' }}>
      <Box>
        <Text size="xs" fw={700} c="teal" mb={6}>紹介キャンペーン</Text>
        <Title order={1} size="h2">紹介キャンペーン登録履歴</Title>
        <Text size="sm" c="dimmed" mt="xs">誰が、誰の紹介で登録したかを確認できます。仮登録・退会済みの履歴も含みます。</Text>
      </Box>

      <Paper withBorder radius="md" p="lg" component="form" action={actionHref} method="get">
        <Stack gap="md">
          <TextInput label="登録者・紹介者を検索" name="keyword" placeholder="氏名・メールアドレス・ユーザーID" defaultValue={filters.keyword || ''} />
          <SimpleGrid cols={{ base: 1, sm: 3 }}>
            <TextInput type="date" label="登録日（開始）" name="from" defaultValue={filters.from || ''} />
            <TextInput type="date" label="登録日（終了）" name="to" defaultValue={filters.to || ''} />
            <NativeSelect label="登録状態" name="status" defaultValue={filters.status || ''} data={[
              { value: '', label: 'すべて' }, { value: 'provisional', label: '仮登録' }, { value: 'confirmed', label: '本登録' },
            ]} />
          </SimpleGrid>
          <Group justify="space-between">
            <Text size="xs" c="dimmed">登録日・本登録日時は日本時間（JST）です。</Text>
            <Group gap="sm"><Button component="a" href={actionHref} variant="subtle" color="gray">条件をクリア</Button><Button type="submit">検索する</Button></Group>
          </Group>
        </Stack>
      </Paper>

      {errors.length > 0 && <Alert color="red" title="検索条件を確認してください" role="alert">{errors.map((error) => <Text size="sm" key={error}>{error}</Text>)}</Alert>}

      {errors.length === 0 && <>
        <Group justify="space-between">
          <Text fw={600}>登録履歴 <Text span size="xl" fw={700} ml="xs">{totalCount.toLocaleString()}</Text> 件</Text>
          <Text size="xs" c="dimmed">登録日時が新しい順 · 25件 / ページ</Text>
        </Group>
        {rows.length === 0 ? (
          <Paper withBorder radius="md" p="xl" ta="center">
            <Text fw={600}>該当する登録履歴はありません</Text>
            <Text size="sm" c="dimmed" mt="xs">検索条件を変更するか、条件をクリアしてください。</Text>
          </Paper>
        ) : <>
          <Paper withBorder radius="md" visibleFrom="sm" style={{ overflow: 'hidden' }}>
            <Table.ScrollContainer minWidth={900}>
              <Table verticalSpacing="md" horizontalSpacing="lg" highlightOnHover style={{ tableLayout: 'fixed' }}>
                <Table.Thead><Table.Tr><Table.Th w="29%">登録者</Table.Th><Table.Th w="29%">紹介者</Table.Th><Table.Th w="14%">登録状態</Table.Th><Table.Th w="28%">登録日時 / 本登録日時</Table.Th></Table.Tr></Table.Thead>
                <Table.Tbody>{rows.map((row) => <Table.Tr key={row.registrant.id}>
                  <Table.Td><Person person={row.registrant} /></Table.Td>
                  <Table.Td><Person person={row.referrer} /></Table.Td>
                  <Table.Td><Status status={row.status} /></Table.Td>
                  <Table.Td><Text size="sm">{row.createdAt}</Text><Text size="xs" c="dimmed" mt={4}>本登録 {row.confirmedAt || '未完了'}</Text></Table.Td>
                </Table.Tr>)}</Table.Tbody>
              </Table>
            </Table.ScrollContainer>
          </Paper>
          <Stack hiddenFrom="sm" gap="sm">{rows.map((row) => <Paper key={row.registrant.id} withBorder radius="md" p="md">
            <Stack gap="md">
              <Group justify="space-between"><Text size="xs" c="dimmed">登録者</Text><Status status={row.status} /></Group>
              <Person person={row.registrant} />
              <Box bg="gray.0" p="sm" style={{ borderRadius: 8 }}><Text size="xs" c="dimmed" mb={6}>紹介者</Text><Person person={row.referrer} /></Box>
              <Box><Text size="xs">登録 {row.createdAt}</Text><Text size="xs" c="dimmed" mt={4}>本登録 {row.confirmedAt || '未完了'}</Text></Box>
            </Stack>
          </Paper>)}</Stack>
        </>}
        <AppPagination {...pagination} />
      </>}
      <Text size="xs" c="dimmed">紹介情報は現在保存されている内容を表示しています。紹介者が未記録の履歴や、氏名のみ残っている履歴も含まれます。</Text>
    </Stack>
  )
}
